window.theme = window.theme || {};
(function ($) {
  "use strict";
  var Echo = {
    init: function () {
      this.Basic.init();
    },

    Basic: {
      init: function () {
        this.smoothScroll();

        this.gridSwiper();
        this.announcementBar();
        this.marqueeScroller();
      },

      smoothScroll: function () {
        $('a[href*="#"]')
          .not('[href="#"]')
          .not('[href="#0"]')
          .click(function (event) {
            // On-page links
            if (
              location.pathname.replace(/^\//, "") ==
              this.pathname.replace(/^\//, "") &&
              location.hostname == this.hostname
            ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length
                ? target
                : $("[name=" + this.hash.slice(1) + "]");
              // Does a scroll target exist?
              if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $(".menu-drawer-container").removeAttr("open");
                $(".menu-drawer-container summary").attr(
                  "aria-expanded",
                  false
                );
                $("body").removeClass("overflow-hidden-tablet");
                $("html, body").animate(
                  {
                    scrollTop: target.offset().top,
                  },
                  600,
                  function () {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) {
                      // Checking if the target was focused
                      return false;
                    } else {
                      $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                      $target.focus(); // Set focus again
                    }
                  }
                );
              }
            }
          });
      },

      gridSwiper: function () {
        class GridSwiper extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.grid__swiper = this.querySelector(".grid__swiper");
            if (!this.grid__swiper) return;
            const resizeObserver = new ResizeObserver((entries) => this.init());
            resizeObserver.observe(this.grid__swiper);
            //  console.log("testdd",this.grid__swiper.dataset)
          }
          init() {
            let centered_slides =
              this.grid__swiper.dataset.centeredslides !== undefined
                ? JSON.parse(this.grid__swiper.dataset.centeredslides)
                : undefined;
            let effect_fade =
              this.grid__swiper.dataset.effectfade !== undefined
                ? JSON.parse(this.grid__swiper.dataset.effectfade)
                : undefined;
            let Gnext = this.querySelector(".swiper-button-next");
            let Gprev = this.querySelector(".swiper-button-prev");
            let pagination = this.querySelector(".swiper-pagination");

            const gridSlider = new Swiper(this.grid__swiper, {
              effect: effect_fade ? "fade" : "slide",
              centeredSlides: centered_slides ? centered_slides : false,
              slidesPerView: parseInt(this.grid__swiper.dataset.slidesmobile),
              spaceBetween: parseInt(this.grid__swiper.dataset.mobilespace),
              grabCursor: false,
              horizontal: true,
              watchSlidesProgress: true,
              draggable: true,
              autoHeight: !1,
              watchOverflow: !0,
              threshold: 10,
              freeMode: true,
              loop: JSON.parse(this.grid__swiper.dataset.loop),
              speed: 1000,
              grid: {
                rows: 2,
              },
              mousewheel: {
                forceToAxis: true,
              },
              autoplay: {
                enabled: JSON.parse(this.grid__swiper.dataset.autoplay),
                disableOnInteraction: false,
                delay: parseInt(this.grid__swiper.dataset.delay),
              },
              navigation: {
                nextEl: Gnext,
                prevEl: Gprev,
              },
              pagination: {
                el: pagination,
                clickable: true,
              },
              breakpoints: {
                359: {
                  slidesPerView: parseFloat(
                    this.grid__swiper.dataset.slidesmobile
                  ),
                  spaceBetween: parseInt(this.grid__swiper.dataset.mobilespace),
                },
                768: {
                  slidesPerView: parseFloat(
                    this.grid__swiper.dataset.slidestab
                  ),
                  spaceBetween: parseInt(this.grid__swiper.dataset.tabspace),
                },
                1024: {
                  slidesPerView: parseFloat(
                    this.grid__swiper.dataset.slidesdesktop
                  ),
                  spaceBetween: parseInt(
                    this.grid__swiper.dataset.desktopspace
                  ),
                },
              },
            });

            return gridSlider;
          }
        }
        customElements.define("grid-slider", GridSwiper);
      },
      announcementBar: function () {
        class AnnouncementBar extends HTMLElement {
          constructor() {
            super();

            this.sessionStorageKey = "announcementBarClosed";
            this.closeButton = this.querySelector("[data-close-button]");
            this.closeButton &&
              this.closeButton.addEventListener(
                "click",
                this.onClose.bind(this)
              );
          }

          connectedCallback() {
            if (sessionStorage.getItem(this.sessionStorageKey)) return;
            this.classList.remove("hidden");
            this.initSlider();
          }

          initSlider() {
            if (!this.querySelector(".swiper")) return;

            this.options = {
              slidesPerPage: 1,
              effect: "fade",
              rewind: true,
              draggable: true,
            };

            if (this.dataset.sliderType !== "controls") {
              this.options.autoplay = {
                delay: 6000,
              };
            } else {
              this.options.navigation = {
                prevEl: "[data-arrow-prev]",
                nextEl: "[data-arrow-next]",
              };
            }

            this.slider = new Swiper(
              this.querySelector(".swiper"),
              this.options
            );
          }

          onClose() {
            this.classList.add("hidden");
            sessionStorage.setItem(this.sessionStorageKey, true);
          }
        }

        customElements.define("announcement-bar", AnnouncementBar);
      },
      marqueeScroller: function () {
        if (!customElements.get("marquee-content")) {
          class EchoMarquee extends HTMLElement {
            constructor() {
              super();
            }
            connectedCallback() {
              this.init();
            }
            calculationPaddingSection() {
              (this.heightSection = this.offsetHeight),
                (this.heightSection =
                  this.heightSection < 18
                    ? 18
                    : 96 < this.heightSection
                      ? 96
                      : this.heightSection),
                this.closest(".js-running-content").style.setProperty(
                  "--spacing-padding-block",
                  this.heightSection + "px"
                );
            }
            init() {
              (this.distance =
                this.querySelector(".js-marquee-item").offsetWidth),
                (this.speed = this.dataset.speed),
                this.style.setProperty(
                  "--marquee-duration",
                  this.distance / this.speed + "s"
                );
            }
          }
          customElements.define("marquee-content", EchoMarquee);
        }
      },
    },
  };

  jQuery(document).ready(function () {
    Echo.init();
  });
})(jQuery);

class slideshowSwiper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sliderWrapper = this.querySelector(".slideshow__swiper");

    let centered_slides =
      this.sliderWrapper.dataset.centeredslides !== undefined
        ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
        : undefined;
    let effect_fade =
      this.sliderWrapper.dataset.effectfade !== undefined
        ? JSON.parse(this.sliderWrapper.dataset.effectfade)
        : undefined;
    let next = this.querySelector(".swiper-button-next");
    let prev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");

    new Swiper(this.sliderWrapper, {
      effect: effect_fade ? "fade" : "slide",
      centeredSlides: centered_slides ? centered_slides : false,
      slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
      spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
      grabCursor: false,
      horizontal: true,
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
      loop: JSON.parse(this.sliderWrapper.dataset.loop),
      speed: 700,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
        disableOnInteraction: false,
        delay: parseInt(this.sliderWrapper.dataset.delay),
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      breakpoints: {
        359: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
          spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
        },
        768: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
          spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
        },
        1024: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
          spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
        },
      },
    });
  }
}
customElements.define("slideshow-swiper", slideshowSwiper);

var ECHelper = window.ECHelper || {};
ECHelper.qs = document.querySelector.bind(document);
ECHelper.qsa = document.querySelectorAll.bind(document);
ECHelper.qid = document.getElementById.bind(document);
ECHelper.qde = document.documentElement;

class EHCLazyLoadingVideo extends HTMLElement {
  constructor() {
    super(),
      (this.iframe = this.querySelector("iframe")),
      (this.template = this.querySelector("template")),
      (this.isMouseenter = !1);
  }
  loadVideo() {
    var t;
    this.iframe &&
      (this.iframe.setAttribute("src", this.iframe.getAttribute("data-src")),
        this.iframe.addEventListener(
          "load",
          function () {
            "youtube" == this.dataVideoType &&
              this.iframe.contentWindow.postMessage(
                '{"event":"command","func":"playVideo","args":""}',
                "*"
              ),
              "vimeo" == this.dataVideoType &&
              this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
          }.bind(this)
        )),
      "local_video" == this.dataVideoType &&
      ((this.local_video = this.querySelector("video")),
        (t = this.local_video.querySelector("source").getAttribute("data-src")),
        (this.local_video.src = t));
  }
  execute() {
    Shopify.designMode
      ? this.loadVideo()
      : (["mousemove", "touchstart"].forEach(
        function (t) {
          ECHelper.qs("body").addEventListener(
            t,
            function (t) {
              this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
            }.bind(this),
            { once: !0 }
          );
        }.bind(this)
      ),
        window.addEventListener(
          "scroll",
          function (t) {
            this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
          }.bind(this),
          { once: !0 }
        ));
  }
  static get observedAttributes() {
    return ["data-video-type", "data-video-id"];
  }
  set dataVideoType(t) {
    this.setAttribute("data-video-type", t);
  }
  get dataVideoType() {
    return this.getAttribute("data-video-type");
  }
  set dataVideoId(t) {
    this.setAttribute("data-video-id", t);
  }
  get dataVideoId() {
    return this.getAttribute("data-video-id");
  }
  attributeChangedCallback(t, e, s) {
    e !== s && this.execute();
  }
  connectedCallback() {
    this.execute();
  }
  disconnectedCallback() { }
}
customElements.define("echo-load-video", EHCLazyLoadingVideo);

class collapsebleComponent extends HTMLElement {
  constructor() {
    super();

    this.collapseble__button = $(this).find(".collapseble__tiem");
    this.collapseble__content = $(this).find(".collapseble__content");
  }

  connectedCallback() {
    $(this.collapseble__button).on("click", function () {
      if (!$(this).hasClass("active")) {
        $(".collapseble__content").slideUp();
        $(".collapseble__tiem").removeClass("active");
        $(this).find(".collapseble__content").slideToggle();
        $(this).toggleClass("active");
      } else {
        $(this).find(".collapseble__content").slideUp();
        $(this).removeClass("active");
      }
    });
  }
}
customElements.define("collapseble-component", collapsebleComponent);

// /best-sellers?&filter.p.tag=Small&sort_by=manual

var main_path = window.location.search;
var filter = {};
var s_filter_val = {};
var filter_path = "";
var sort_value = $(".select-sort-js").val();

$(document).on("click", ".filter-toggler", function (e) {
  e.preventDefault();
  $("body").toggleClass("open-filter");
});
$(document).on("click", ".overlay, .close_filter", function (e) {
  e.preventDefault();
  $("body").removeClass("open-filter");
});

$(window).on("resize", function () {
  var win = $(this);
  if (win.width() >= 992) {
    $(".filters__filter-wrap").removeAttr("style");
    $(".filter-button").addClass("filter-desktop-js");
    $(".filter-button").removeClass("filter-mobile-js");
    $(".filters__item-mobile").addClass("filters__item");
    $(".filters__item-mobile").removeClass("filters__item-mobile");
  }

  if (win.width() <= 991) {
    $(".filter-button").removeClass("filter-desktop-js");
    $(".filter-button").addClass("filter-mobile-js");
    $(".filters__item").addClass("filters__item-mobile");
    $(".filters__item").removeClass("filters__item");
  }
});

function windowLoad() {



  $(window).on("load", function () {
    var win = $(this);
    if (win.width() >= 992) {
      $(".filters__filter-wrap").removeAttr("style");
      $(".filter-button").addClass("filter-desktop-js");
      $(".filter-button").removeClass("filter-mobile-js");
      $(".filters__item-mobile").addClass("filters__item");
      $(".filters__item-mobile").removeClass("filters__item-mobile");
    }

    if (win.width() <= 991) {
      $(".filter-button").removeClass("filter-desktop-js");
      $(".filter-button").addClass("filter-mobile-js");
      $(".filters__item").addClass("filters__item-mobile");
      $(".filters__item").removeClass("filters__item");
    }
  });


}

windowLoad();




function ajaxniateLoad(){
  document.addEventListener("DOMContentLoaded", function() {

    window.endlessScroll = new Ajaxinate({
      container: '#AjaxinateLoop',
      pagination: '#AjaxinatePagination'
    });


    window.endlessScrollx = new Ajaxinate({
      container: '#AjaxinateLoopx',
      pagination: '#AjaxinatePaginationx'
    });


    });

      document.addEventListener("DOMContentLoaded", function() {

        window.endlessScroll1 = new Ajaxinate({
          container: '#AjaxinateLoop-1',
          pagination: '#AjaxinatePagination-1',
          method: 'click',
          offset: 24
        });
        window.endlessScroll2 = new Ajaxinate({
          container: '#AjaxinateLoop-2',
          pagination: '#AjaxinatePagination-2',
          method: 'click',
          offset: 24
        });
        window.endlessScroll3 = new Ajaxinate({
          container: '#AjaxinateLoop-3',
          pagination: '#AjaxinatePagination-3',
          method: 'click',
          offset: 24
        });
        window.endlessScroll4 = new Ajaxinate({
          container: '#AjaxinateLoop-4',
          pagination: '#AjaxinatePagination-4',
          method: 'click',
          offset: 24
        });
        window.endlessScroll5 = new Ajaxinate({
          container: '#AjaxinateLoop-5',
          pagination: '#AjaxinatePagination-5',
          method: 'click',
          offset: 24
        });
        window.endlessScroll6 = new Ajaxinate({
          container: '#AjaxinateLoop-6',
          pagination: '#AjaxinatePagination-6',
          method: 'click',
          offset: 24
        });
        window.endlessScroll7 = new Ajaxinate({
          container: '#AjaxinateLoop-7',
          pagination: '#AjaxinatePagination-7',
          method: 'click',
          offset: 24
        });
        window.endlessScroll8 = new Ajaxinate({
          container: '#AjaxinateLoop-8',
          pagination: '#AjaxinatePagination-8',
          method: 'click',
          offset: 24
        });


      });
}


ajaxniateLoad();



$(document).on("click", ".filters__label-mobile", function (e) {
  e.preventDefault();
  $(".filters__filter-wrap").slideUp();
  if ($(this).closest(".filters__item-mobile").hasClass("active")) {
    $(this).closest(".filters__item-mobile").removeClass("active");
    $(".filters__filter-wrap").slideUp();
  } else {
    $(".filters__item-mobile").removeClass("active");
    $(this).closest(".filters__item-mobile").addClass("active");
    $(this).siblings(".filters__filter-wrap").slideDown();
  }
});

$(document).on("click", ".filters__label", function (e) {
  e.preventDefault();
  if ($(this).closest(".filters__item").hasClass("active")) {
    $(this).closest(".filters__item").removeClass("active");
    $("body").removeClass("open");
  } else {
    $(".filters__item").removeClass("active");
    $(this).closest(".filters__item").addClass("active");
    $("body").addClass("open");
  }
});

function filterCheckbox(sort_value, s_filter, filter_path) {
  var cehcked = false;

  $(".filter-button").each(function (index) {
    if ($(this).hasClass("active")) {
      cehcked = true;
    }
  });

  if (cehcked) {
    $(".filter-button.active").each(function (index) {
      var filter_inputs = $(this).find("input.filters__input");
      var parent_index = index;
      s_filter = "";
      filter_inputs.each(function (index) {
        filter[parent_index] = $(this).attr("name");
        s_filter_val[parent_index] = $(this).val();

        s_filter +=
          "&" + filter[parent_index] + "=" + s_filter_val[parent_index];
      });
      filter_path = filter_path + s_filter;
    });

    if (sort_value != null) {
      filter_path = filter_path + "&sort_by=" + sort_value;
    } else {
      filter_path = filter_path;
    }

    FetchCollectionGrid(filter_path);
    history.pushState({}, null, window.location.origin + filter_path);
  } else {
    if (sort_value != null) {
      filter_path = filter_path + s_filter + "&sort_by=" + sort_value;
    } else {
      filter_path = filter_path + s_filter;
    }
    FetchCollectionGrid(filter_path);
    history.pushState({}, null, window.location.origin + filter_path);
  }
}

$(document).on("click", ".filter-desktop-js", function (e) {
  e.preventDefault();

  $(this).toggleClass("active");
  $("html, body").animate({ scrollTop: 0 }, 500);

  var list = [];
  $(".filter-button.active").each(function (index) {
    var checkbox_value = $(this).find("input[type='checkbox']");
    list.push(checkbox_value.val());
  });

  var filter_path = window.location.pathname + "?";
  var s_filter = "";
  sort_value = $(".select-sort-js").val();
  filterCheckbox(sort_value, s_filter, filter_path);
});

$(document).on("click", ".filter-mobile-js", function (e) {
  e.preventDefault();
  $(this).toggleClass("active");
  $("html, body").animate({ scrollTop: 0 }, 500);

  var list = [];
  $(".filter-button.active").each(function (index) {
    var checkbox_value = $(this).find("input[type='checkbox']");
    list.push(checkbox_value.val());
  });

  var filter_path = window.location.pathname + "?";
  var s_filter = "";
  sort_value = $(".select-sort-js").val();

  var cehcked = false;
  $(".filter-button").each(function (index) {
    if ($(this).hasClass("active")) {
      cehcked = true;
    }
  });

  if (cehcked) {
    $(".filter-button.active").each(function (index) {
      var filter_inputs = $(this).find("input.filters__input");
      var parent_index = index;
      s_filter = "";
      filter_inputs.each(function (index) {
        filter[parent_index] = $(this).attr("name");
        s_filter_val[parent_index] = $(this).val();

        s_filter +=
          "&" + filter[parent_index] + "=" + s_filter_val[parent_index];
      });
      filter_path = filter_path + s_filter;
    });

    if (sort_value != null) {
      filter_path = filter_path + "&sort_by=" + sort_value;
    } else {
      filter_path = filter_path;
    }

    RenderClarButton(filter_path);
    history.pushState({}, null, window.location.origin + filter_path);
  } else {
    if (sort_value != null) {
      filter_path = filter_path + s_filter + "&sort_by=" + sort_value;
    } else {
      filter_path = filter_path + s_filter;
    }
    RenderClarButton(filter_path);
    history.pushState({}, null, window.location.origin + filter_path);
  }
});

$(document).on("click", ".apply-filter-button", function (e) {
  e.preventDefault();
  var filter_path = window.location.pathname + "?";
  var s_filter = "";
  sort_value = $(".select-sort-js").val();

  $(".filter-button.active").each(function (index) {
    var filter_inputs = $(this).find("input.filters__input");
    var parent_index = index;
    s_filter = "";
    filter_inputs.each(function (index) {
      filter[parent_index] = $(this).attr("name");
      s_filter_val[parent_index] = $(this).val();

      s_filter += "&" + filter[parent_index] + "=" + s_filter_val[parent_index];
    });
    filter_path = filter_path + s_filter;
  });

  if (sort_value != null) {
    filter_path = filter_path + "&sort_by=" + sort_value;
  } else {
    filter_path = filter_path;
  }

  FetchCollectionGrid(filter_path);
  history.pushState({}, null, window.location.origin + filter_path);

  // console.log("filter_path", filter_path);
  setTimeout(function () {
    $("body").removeClass("open-filter");
  }, 500);
});

$(document).on("click", ".custom_sort-button", function (e) {
  e.preventDefault();

  var facets__sort = $(this).closest(".custom-facets__sort");
  facets__sort.toggleClass("active");
});

$(document).on("click", ".dropdown__sort_link", function (e) {
  e.preventDefault();
  var facets__sort = $(this).closest(".custom-facets__sort");
  var select = facets__sort.find("select");

  $(".dropdown__sort_link").removeAttr("disabled");
  $(this).attr("disabled", true);

  //  lebel change
  var srt_button = facets__sort.find(".custom_sort-button");
  var selected_text = $(this).text();
  srt_button.find("span[data-label]").text(selected_text);

  var options = select.find("option");
  var sort_value = $(this).data("value");
  select.find("option").removeAttr("selected");
  options.each(function () {
    if (sort_value === this.value) {
      $(this).attr("selected", "selected");
    }
  });

  var filter_path = window.location.pathname + "?";
  var s_filter = "";
  filterCheckbox(sort_value, s_filter, filter_path);
  facets__sort.removeClass("active");
});

$(".filters__filter-wrap").on("mouseleave", function () {
  var target = $(this);
  setTimeout(function () {
    target.closest(".filters__item").removeClass("active");

    if (target.length > 0) {
      $("body").removeClass("open");
    }
  }, 700);
});

function RenderClarButton(filter_path) {
  fetch(filter_path + "&section_id=main-collection")
    .then((response) => response.text())
    .then((collectionData) => {
      var collection_html = $(collectionData);
      var clear_button = $("#clear_button", collection_html);
      $("#clear_button").replaceWith(clear_button);

      var dynamic_category = $("#dynamic_category", collection_html);
      $("#dynamic_category").replaceWith(dynamic_category);

      var filter__category_dynamic = $("#filter__category_dynamic", collection_html);
      $("#filter__category_dynamic").replaceWith(filter__category_dynamic);

      if ($(window).width() >= 992) {
        $(".filters__filter-wrap").removeAttr("style");
        $(".filter-button").addClass("filter-desktop-js");
        $(".filter-button").removeClass("filter-mobile-js");
        $(".filters__item-mobile").addClass("filters__item");
        $(".filters__item-mobile").removeClass("filters__item-mobile");
      }


      if ($(window).width() <= 991) {
        $(".filter-button").removeClass("filter-desktop-js");
        $(".filter-button").addClass("filter-mobile-js");
        $(".filters__item").addClass("filters__item-mobile");
        $(".filters__item").removeClass("filters__item");
      }


    });
}

function FetchCollectionGrid(filter_path) {
  fetch(filter_path + "&section_id=main-collection")
    .then((response) => response.text())
    .then((collectionData) => {
      var collection_html = $(collectionData);
      var collection_items = $("#ProductGridContainer", collection_html);

      $("#ProductGridContainer").replaceWith(collection_items);

      var result = $("#dynamic-result", collection_html);
      $("#dynamic-result").replaceWith(result);

      var result = $("#dynamic_category", collection_html);
      $("#dynamic_category").replaceWith(result);

      var result = $("#filter__category_dynamic", collection_html);
      $("#filter__category_dynamic").replaceWith(result);

      if ($(".filter-button.active").length > 0) {
        $(".collecion-sub-section").addClass("d-none");
      } else {
        $(".collecion-sub-section").removeClass("d-none");
      }


      
       // Reinitialize Ajaxinate for infinite scroll
       window.endlessScroll.destroy(); // Destroy the old instance
       window.endlessScroll = new Ajaxinate({
         container: '#AjaxinateLoop',
         pagination: '#AjaxinatePagination'
       });

       window.endlessScrollx = new Ajaxinate({
        container: '#AjaxinateLoopx',
        pagination: '#AjaxinatePaginationx'
      });

       

      
      if ($(window).width() >= 992) {
        $(".filters__filter-wrap").removeAttr("style");
        $(".filter-button").addClass("filter-desktop-js");
        $(".filter-button").removeClass("filter-mobile-js");
        $(".filters__item-mobile").addClass("filters__item");
        $(".filters__item-mobile").removeClass("filters__item-mobile");
      }


      if ($(window).width() <= 991) {
        $(".filter-button").removeClass("filter-desktop-js");
        $(".filter-button").addClass("filter-mobile-js");
        $(".filters__item").addClass("filters__item-mobile");
        $(".filters__item").removeClass("filters__item");
      }

    });
}

$(document).on("click", ".filter__category-toggler", function (e) {
  e.preventDefault();

  if ($(this).closest(".filter__category-mobile").hasClass("active")) {
    $(this).closest(".filter__category-mobile").removeClass("active");
    $("body").removeClass("open-overlay");
  } else {
    $(".filter__category-mobile").removeClass("active");
    $("body").addClass("open-overlay");
    $(this).closest(".filter__category-mobile").addClass("active");
  }
});

$(document).on("click", ".dropdown__list-link", function (e) {
  e.preventDefault();

  $(".dropdown__list-link").removeClass("active");
  $(this).addClass("active");
  var button_lebel = $(this).text();
  $(".filter__category-toggler").find(".shob-by").text(button_lebel);

  var id = $(this).data("id");
  $("html, body").animate(
    {
      scrollTop: $(id).offset().top - 220,
    },
    500
  );

  $(".filter__category-mobile").removeClass("active");
  $("body").removeClass("open-overlay");
});

$(document).on("click", ".collection__grid--inner-overlay", function (e) {
  e.preventDefault();

  $(".filter__category-mobile").removeClass("active");
  $("body").removeClass("open-overlay");
});



$(document).on("click", "button.clearAllbutton", function (e) {
  var filter_path = window.location.pathname;

  fetch(filter_path + "?section_id=main-collection")
    .then((response) => response.text())
    .then((collectionData) => {
      var collection_html = $(collectionData);
      var collection_items = $("#ProductGridContainer", collection_html);
      $("#ProductGridContainer").replaceWith(collection_items);



      var filter_dynamic = $("#filter_dynamic", collection_html);
      $("#filter_dynamic").replaceWith(filter_dynamic);

      var dynamic_category = $("#dynamic_category", collection_html);
      $("#dynamic_category").replaceWith(dynamic_category);

      var filter__category_dynamic = $(
        "#filter__category_dynamic",
        collection_html
      );
      $("#filter__category_dynamic").replaceWith(filter__category_dynamic);

      $(".collecion-sub-section").removeClass("d-none");


      if ($(window).width() >= 992) {
        $(".filters__filter-wrap").removeAttr("style");
        $(".filter-button").addClass("filter-desktop-js");
        $(".filter-button").removeClass("filter-mobile-js");
        $(".filters__item-mobile").addClass("filters__item");
        $(".filters__item-mobile").removeClass("filters__item-mobile");
      }



      if ($(window).width() <= 991) {
        $(".filter-button").removeClass("filter-desktop-js");
        $(".filter-button").addClass("filter-mobile-js");
        $(".filters__item").addClass("filters__item-mobile");
        $(".filters__item").removeClass("filters__item");
      }


      history.pushState({}, null, filter_path);
    });
});

$(document).on("click", "button.remove-filter-button", function (e) {
  var filter_path = $(this).data("remove-to");

  fetch(filter_path + "?section_id=main-collection")
    .then((response) => response.text())
    .then((collectionData) => {
      var collection_html = $(collectionData);
      var collection_items = $("#ProductGridContainer", collection_html);
      $("#ProductGridContainer").replaceWith(collection_items);

      var filter_dynamic = $("#filter_dynamic", collection_html);
      $("#filter_dynamic").replaceWith(filter_dynamic);

      var dynamic_category = $("#dynamic_category", collection_html);
      $("#dynamic_category").replaceWith(dynamic_category);

      var filter__category_dynamic = $(
        "#filter__category_dynamic",
        collection_html
      );
      $("#filter__category_dynamic").replaceWith(filter__category_dynamic);

      $(".collecion-sub-section").removeClass("d-none");


      if ($(window).width() >= 992) {
        $(".filters__filter-wrap").removeAttr("style");
        $(".filter-button").addClass("filter-desktop-js");
        $(".filter-button").removeClass("filter-mobile-js");
        $(".filters__item-mobile").addClass("filters__item");
        $(".filters__item-mobile").removeClass("filters__item-mobile");
      }


      if ($(window).width() <= 991) {
        $(".filter-button").removeClass("filter-desktop-js");
        $(".filter-button").addClass("filter-mobile-js");
        $(".filters__item").addClass("filters__item-mobile");
        $(".filters__item").removeClass("filters__item");
      }


      history.pushState({}, null, filter_path);
    });
});

if ($(".section-scroll").length) {
  $(window)
    .scroll(function () {
      //console.log('test')
      var scrollDistance = $(window).scrollTop();
      $(".section-scroll").each(function (i) {
        if ($(this).position().top <= scrollDistance) {
          $(".category--flex li button.active").removeClass("active");
          $(".category--flex li button").eq(i).addClass("active");
        }
      });
    })
    .scroll();
}

$(document).on("click", function (e) {
  var facets__sort = $(".custom-facets__sort");
  if (!facets__sort.is(e.target) && facets__sort.has(e.target).length === 0) {
    facets__sort.removeClass("active");
  }

  var filters__item = $(".filters__item");
  if (!filters__item.is(e.target) && filters__item.has(e.target).length === 0) {
    filters__item.removeClass("active");
    $("body").removeClass("open");
  }

  var filters__item = $(".filter__category-mobile");
  if (!filters__item.is(e.target) && filters__item.has(e.target).length === 0) {
    filters__item.removeClass("active");
    $("body").removeClass("open-overlay");
  }

  e.stopPropagation();
});

// console.log("Tess Path", filter_path);

// $('.collecion-sub-section').each(function () {
//   var path = $(this).data("path")+"?&sort_by=" + sort_value;
//   console.log("Tess", path);

//     sorSubCollection(path);

// });

function sorSubCollection(filter_path) {
  fetch(filter_path + "&section_id=main-collection")
    .then((response) => response.text())
    .then((collectionData) => {
      var collection_html = $(collectionData);

      collection_html.each(function () {
        var sub_product_grid = $(
          "#collecion-sub-product-grid",
          collection_html
        );
        $("#collecion-sub-product-grid").replaceWith(sub_product_grid);

        console.log("Tess", sub_product_grid);
      });

      //  $("#collecion-sub-product-grid").replaceWith(sub_product_grid);
    });
}





$(document).on("click", "button.button__accordian", function (e) {
  $(this).siblings('.accordian_content_wrap').slideToggle();
  $(this).toggleClass('active');
});

$(document).on("click", "button.apply-discount-code", function (e) {
  const discountCode = $(this).closest('.cart-discount').find('[name="discount"]').val();
  var btn = $(this);
  // console.log("Tress", discountCode);

  if (discountCode) {
    btn.addClass('btn--loading');
    document.cookie = `discount_code=${discountCode}; path=/`;
    fetch(`/discount/${discountCode}`)
      .then(function () {

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: {},
          }),
        });
      })
      .then(function (data) {
        fetch('?section_id=cart-drawer')
          .then((response) => response.text())
          .then((cartData) => {
            btn.removeClass('btn--loading');
            var cart_html = $(cartData);
            var cart_items = $('#CartDrawer-CartItems', cart_html);
            $('#CartDrawer-CartItems').replaceWith(cart_items);
            var cart_items = $('#cart_summary_updated', cart_html);
            $('#cart_summary_updated').replaceWith(cart_items);

          });
      })
      .catch(function (error) {
        console.error('Error:', error);
      });


  }

});




var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount_no_decimals}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantInput();
    this.updatePrice();
    this.updateImage();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });


    this.toggleAddButton(!this.currentVariant.available, "Sold Out");

  }


  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updatePrice() {
    const productPrice = this.offsetParent.querySelector(`#upsell-price-${this.dataset.section}`);
    productPrice.innerHTML = "add to cart - " + Shopify.formatMoney(this.currentVariant.price, window.theme.moneyFormat);

  }


  updateImage() {
    const upsellImage = this.offsetParent.querySelector(`#upsell-image-${this.dataset.section}`);
    if (this.currentVariant.featured_image != null) {
      upsellImage.querySelector('img').src = this.currentVariant.featured_image.src
      upsellImage.querySelector('img').srcset = this.currentVariant.featured_image.src
      upsellImage.querySelector('img').setAttribute("data-src", this.currentVariant.featured_image.src);
    }

  }

  updateVariantInput() {


    const productForms = document.querySelectorAll(`#Card-Drawer-Upsell-Form-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      // input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }



  toggleAddButton(disable = true, text, modifyClass = true) {


    const productForm = this.offsetParent.querySelector(`#Card-Drawer-Upsell-Form-${this.dataset.section}`);

    const productPrice = this.offsetParent.querySelector(`#upsell-price-${this.dataset.section}`);


    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"]  span.js-product-form-submit-btn-text');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = "add to cart - " + Shopify.formatMoney(this.currentVariant.price, window.theme.moneyFormat);
    }

    if (!modifyClass) return;




  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

}
customElements.define('variant-selects', VariantSelects);


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);





$(document).on("click", ".js-quantity-selector-toggle", function (e) {
  e.preventDefault();
  $('.js-quantity-selector').toggleClass('active');
});

$(document).on("click", ".js-quantity-selector-option-btn", function (e) {
  e.preventDefault();
  $('.js-quantity-selector-option').removeClass("QuantitySelector__option--selected");
  $(this).closest('.js-quantity-selector-option').addClass("QuantitySelector__option--selected");

  var value = $(this).data('value');

  $('.js-quantity-input').val(value);
  $('.js-selected-quantity').text(value);



  $('.js-quantity-selector').removeClass('active');
});




$('.PDPTabs__nav__item').on('click', function () {
  var target = $(this).attr('data-id');
  $('.PDPTabs__nav__item').removeClass('PDPTabs__nav__item--active');
  $('.PDPTabs__nav__item').find('.PDPTabs__nav__underline').removeClass('PDPTabs__nav__underline--active');
  $(this).addClass('PDPTabs__nav__item--active');
  $(this).find('.PDPTabs__nav__underline').addClass('PDPTabs__nav__underline--active');
  $("#" + target).fadeIn('slow').siblings(".tab__content").hide();
  return false;
});





function accordionResize() {
  if ($(window).width() < 767) {

    var accordion_items = $(".accordion-item__custom");
    if (accordion_items != null) {
      accordion_items.each(function (index) {
        $(this).find(".accordion-item--product").removeClass("is-open");
        $(this).find(".accordion-item--product").removeAttr('open');
      });
    }
  }
}

/* Call the function */
accordionResize();



var faq_search = document.getElementById('faq-search');


if (faq_search != null) {

  faq_search.addEventListener('input', function () {
    const query = this.value.toLowerCase().trim();
    const titles = document.querySelectorAll('.faq__title');

    titles.forEach(title => {
      const faqItems = [];

      // Find the FAQ items below the current title
      let nextElement = title.nextElementSibling;
      while (nextElement && nextElement.classList.contains('faq-item')) {
        faqItems.push(nextElement);
        nextElement = nextElement.nextElementSibling;
      }

      // Check if any FAQ items match the search query
      let hasMatch = false;
      faqItems.forEach(item => {
        const titleElement = item.querySelector('summary span');
        const titleText = titleElement ? titleElement.textContent.toLowerCase() : '';

        if (query === '' || titleText.includes(query)) {
          item.style.display = ''; // Show matching item
          hasMatch = true;
        } else {
          item.style.display = 'none'; // Hide non-matching item
        }
      });

      // Show or hide the title based on whether there are matching FAQ items
      title.style.display = hasMatch ? '' : 'none';
    });
  });

}



$('.tabs__nav__item').on('click', function () {
  var target = $(this).attr('data-id');
  $('.tabs__nav__item').removeClass('active');
  $(this).addClass('active');
  $("#" + target).fadeIn('slow').siblings(".tab-content").hide();
  return false;
});






var QHRHelper = window.QHRHelper || {};
QHRHelper.qs = document.querySelector.bind(document);
QHRHelper.qsa = document.querySelectorAll.bind(document);
QHRHelper.qid = document.getElementById.bind(document);
QHRHelper.qde = document.documentElement;

class QHRLoadingVideo extends HTMLElement {
  constructor() {
    super(),
      (this.iframe = this.querySelector("iframe")),
      (this.template = this.querySelector("template")),
      (this.isMouseenter = !1);
  }
  loadVideo() {
    var t;
    this.iframe &&
      (this.iframe.setAttribute("src", this.iframe.getAttribute("data-src")),
        this.iframe.addEventListener(
          "load",
          function () {
            "youtube" == this.dataVideoType &&
              this.iframe.contentWindow.postMessage(
                '{"event":"command","func":"playVideo","args":""}',
                "*"
              ),
              "vimeo" == this.dataVideoType &&
              this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
          }.bind(this)
        )),
      "local_video" == this.dataVideoType &&
      ((this.local_video = this.querySelector("video")),
        (t = this.local_video.querySelector("source").getAttribute("data-src")),
        (this.local_video.src = t));
  }
  execute() {
    Shopify.designMode
      ? this.loadVideo()
      : (["mousemove", "touchstart"].forEach(
        function (t) {
          QHRHelper.qs("body").addEventListener(
            t,
            function (t) {
              this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
            }.bind(this),
            { once: !0 }
          );
        }.bind(this)
      ),
        window.addEventListener(
          "scroll",
          function (t) {
            this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
          }.bind(this),
          { once: !0 }
        ));
  }
  static get observedAttributes() {
    return ["data-video-type", "data-video-id"];
  }
  set dataVideoType(t) {
    this.setAttribute("data-video-type", t);
  }
  get dataVideoType() {
    return this.getAttribute("data-video-type");
  }
  set dataVideoId(t) {
    this.setAttribute("data-video-id", t);
  }
  get dataVideoId() {
    return this.getAttribute("data-video-id");
  }
  attributeChangedCallback(t, e, s) {
    e !== s && this.execute();
  }
  connectedCallback() {
    this.execute();
  }
  disconnectedCallback() { }
}
customElements.define("qhr-load-video", QHRLoadingVideo);






// video-thumbnails



$('.video-thumbnails').on('click', function (e) {

  e.preventDefault();

  $(".product__media-slide").find("video").each(function (index) {
    $(this).get(0).pause();
  });
  var target = $(this).attr('data-id');
  var video = $("#" + target).find("video");
  var video = $("[data-video-id=" + target + "]").find("video");

  if (video != null) {
    video.get(0).play();
  }


});




$(document).on("click", "button.scroll_button", function (e) {

  $("button.scroll_button").removeClass("active");
  $(this).addClass("active");
  var id = $(this).data("id");
  $("html, body").animate(
    {
      scrollTop: $(id).offset().top - 310,
    },
    500
  );
});




